import { Pipe, PipeTransform } from '@angular/core';

import { isRecommendationActive } from 'src/app/_shared/interface/recommendation.interface';
import { WrapperPipeMixin } from 'src/app/_shared/pipes/wrapper-mixin.pipe';

@Pipe({ name: 'recommendationActive' })
export class RecommendationActivePipe extends WrapperPipeMixin(isRecommendationActive) implements PipeTransform {}
